import RoleScreen from './containers/roleScreen'

export {default as RoleScreenLayout} from './components/roleScreenLayout'

export default RoleScreen
